import { forwardRef } from "react";

const InteractiveDiv = forwardRef(({
  children,
  className = "",
  style = {},
  disabled = false,
  onClick,
  onKeyDown,
  tabIndex: tabIndexProp,
  ...rest
}, ref) => {
  const tabIndex = disabled ? -1 : (tabIndexProp !== undefined && tabIndexProp !== null ? tabIndexProp : 0);

  const handleKeyDown = (e) => {
    if (disabled) return;
    if (!disabled) {
      if (e.key === "Enter") {
        e.preventDefault();
        onClick?.(e);
        return;
      }
      if (e.key === " ") {
        // Only prevent the page scroll, the click action will fire on keyup to match native buttons
        e.preventDefault();
        return;
      }
    }
    onKeyDown?.(e);
  };

  const handleKeyUp = (e) => {
    if (disabled) return;
    if (e.key === " ") {
      onClick?.(e);
    }
  };

  const handleClick = (e) => {
    if (disabled) return;
    onClick?.(e);
  };

  return (
    <div
      ref={ref}
      className={className}
      style={{ cursor: disabled ? "not-allowed" : "pointer", ...style }}
      role="button"
      tabIndex={tabIndex}
      aria-disabled={disabled || undefined}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      onKeyUp={handleKeyUp}
      {...rest}
    >
      {children}
    </div>
  );
});

InteractiveDiv.displayName = "InteractiveDiv";

export default InteractiveDiv;